import { filterMarketplacePayload } from "./marketplaceProductVisibility";

export const fetchMarketSection = async (url) => {
  const response = await fetch(url);

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }

  const data = await response.json();
  return filterMarketplacePayload(data);
};
